<template>
  <el-card
    shadow="always"
    :body-style="{ padding: '20px' }"
    v-loading="loading"
  >
    <DepositesFilterForm />

    <div v-if="depositAccounts.docs">
      <el-table
        :data="depositAccounts.docs"
        @sort-change="handleSortChange"
        :default-sort="{ prop: '_id', order: 'descending' }"
        :row-class-name="tableRowClassName"
        size="mini"
        border
        stripe
      >
        <el-table-column sortable="custom" prop="_id" label="ID" width="90">
          <template slot-scope="scope">
            {{ scope.row._id.slice(-6) }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          sortable="custom"
          prop="balanceAccount"
          label="ID"
          width="90"
        >
          <template slot-scope="scope">
            {{ scope.row.balanceAccount._id.slice(-6) }}
          </template>
        </el-table-column> -->
        <el-table-column sortable="custom" prop="title" label="Название">
          <template slot-scope="scope">
            {{ scope.row.title }}
          </template>
        </el-table-column>
        <el-table-column label="Комментарий">
          <template slot-scope="scope">
            {{ scope.row.exchange && scope.row.exchange.comment }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="balanceAccount.title" label="Название">
          <template slot-scope="scope">
            {{ scope.row.balanceAccount.title }}
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="ledgerExchange" label="Пользователь">
          <template slot-scope="scope">
            {{ scope.row.ledgerExchange.userName }}
          </template>
        </el-table-column> -->

        <el-table-column
          sortable="custom"
          prop="balance"
          label="Баланс"
          width="180"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="balanceAccount.balance"
          label="Баланс"
          width="180"
        >
        </el-table-column> -->
        <el-table-column
          sortable="custom"
          prop="valute"
          label="Валюта"
          width="180"
        >
          <template slot-scope="scope">
            {{ scope.row.valute && scope.row.valute.name }}
          </template>
        </el-table-column>
        <el-table-column sortable="custom" prop="createdAt" label="Создан">
          <template slot-scope="scope">
            <div v-if="scope.row.createdAt">
              {{ formatDT(scope.row.createdAt).date }}
              <hr />
              {{ formatDT(scope.row.createdAt).time }}
            </div>
            <div v-else>
              N/A
            </div>
          </template>
        </el-table-column>
        <el-table-column sortable="custom" prop="updatedAt" label="Изменен">
          <template slot-scope="scope">
            <div v-if="scope.row.updatedAt">
              {{ formatDT(scope.row.updatedAt).date }}
              <hr />
              {{ formatDT(scope.row.updatedAt).time }}
            </div>
            <div v-else>
              N/A
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="exchange" label="Операция" width="180">
          <template slot-scope="scope">
            {{ scope.row.exchange }}
          </template>
        </el-table-column> -->
        <el-table-column fixed="right" label="Действия" width="150">
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">Открыть связанную операцию</div>
              <el-button
                size="small"
                icon="el-icon-edit"
                @click="
                  $router.push({
                    name: 'LedgerEdit',
                    params: getParams(scope.row)
                  })
                "
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleDepositPage"
        :current-page.sync="depositAccounts.page"
        :page-size="depositAccounts.limit"
        layout="prev, pager, next, jumper"
        :total="depositAccounts.totalDocs"
      >
      </el-pagination>
    </div>
  </el-card>
</template>
<script>
import { mapState, mapActions } from "vuex";

import DepositesFilterForm from "../../../../ui/DepositesFilterForm.vue";
export default {
  name: "LedgerDepositesComponent",
  data: () => ({}),
  components: { DepositesFilterForm },
  computed: {
    ...mapState("depositAccounts", ["depositAccounts", "loading"]),
    ...mapState("valutes", ["valutes"]),
    valutesOptions() {
      return this.valutes.map(valute => {
        return {
          value: valute._id,
          label: valute.title
        };
      });
    }
  },
  methods: {
    ...mapActions("depositAccounts", [
      "getDepositAccounts",
      "goToPage",
      "changeSorting"
    ]),
    ...mapActions("valutes", ["getValutes", "getSortedValutes"]),
    getParams(row) {
      const id = row.exchange ? row.exchange._id : row.title.split(" ")[1];
      return {
        id
      };
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isNew) {
        return "new-row";
      }
      return "";
    },
    formatDT(dt) {
      if (!dt) return undefined;
      return {
        date: this.$dayjs(dt).format("YYYY-MM-DD"),
        time: this.$dayjs(dt).format("HH:mm")
      };
    },

    async handleSortChange(sortData) {
      const sort =
        sortData.order === "ascending"
          ? sortData.prop
          : sortData.order === "descending"
          ? `-${sortData.prop}`
          : "";
      await this.changeSorting({ sort });
    },
    handleDepositPage(page) {
      this.goToPage({ page });
    }
  },
  async mounted() {
    if (!this.valutes.length) await this.getSortedValutes();
    await this.getDepositAccounts();
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/pages/Ledger/components/Balances/deposites.vue